/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TipoTransazioneVoucher } from './tipo-transazione-voucher';


export interface TransazioneVoucherListItemDTO { 
    id?: string;
    data?: string;
    tipo_transazione?: TipoTransazioneVoucher;
    valore_transazione?: number;
    valore_scontrino?: number;
    numero_scontrino?: string;
    id_negozio?: string;
    nome_negozio?: string;
    id_tipo_pratica?: string;
    titolo_bando?: string;
    codice_bando?: string;
}



